export const formatPatrimonialChart = (adapted, { primaryColor } = {}) => {
  if (!adapted || !adapted.ok || !adapted.evolucao_patrimonial) {
    return cloneEmpty()
  }

  const ep = adapted.evolucao_patrimonial
  const labels = Array.isArray(ep.data) ? ep.data : []
  const values = Array.isArray(ep.patrimonio) ? ep.patrimonio : []

  if (labels.length === 0 || values.length === 0) return cloneEmpty()

  return {
    labels,
    datasets: [
      {
        label: 'P/L',
        name: 'P/L',
        type: 'bar',
        order: 1,
        backgroundColor: primaryColor,
        borderWidth: 1,
        data: values,
      },
    ],
  }
}

const cloneEmpty = () => ({ labels: [], datasets: [] })
